import { useContext } from "react";
import { WplywContext } from "../../../../context/wplywContext";
import { useState, useEffect } from "react";
import getFilledPersonOwnIds from "../../../../components/getFilledPersonOwnIds";

const useStage2 = () => {
    const { wplyw } = useContext(WplywContext);
    const [totals, setTotals] = useState(
        parseFloat((parseFloat(wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_amount) - 
        parseFloat(wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_deduction)).toFixed(2))
    );

    useEffect(() => {
        setTotals(
            parseFloat((parseFloat(wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_amount) - 
            parseFloat(wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_deduction)).toFixed(2))
        );
    }, [wplyw]);

    const [totals2, setTotals2] = useState(
        parseFloat(wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_deduction)
    );

    useEffect(() => {
        setTotals2(parseFloat(wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_deduction.toFixed(2)));
    }, [wplyw]);

    const remainingDeductions = parseFloat((
        totals2 -
        wplyw.wplyw_data.data.msr_wplywy.msr_persons.reduce(
            (sum, person) => sum + parseFloat((person.msr_persons_deduction || 0).toFixed(2)),
            0
        )).toFixed(2));

    if (!wplyw?.wplyw_data) return false;

    const filled = getFilledPersonOwnIds(wplyw);
    const cont = wplyw.wplyw_data.data.msr_wplywy.msr_persons.length > 0;
    const filledany = filled.length > 0;
    const deds = remainingDeductions >= 0;
    const amountSum = parseFloat(wplyw.wplyw_data.data.msr_wplywy.msr_persons.reduce(
        (sum, person) => sum + parseFloat((person.msr_persons_amount || 0).toFixed(2)),
        0
    ).toFixed(2));
    const amount = parseFloat(amountSum.toFixed(2)) === parseFloat(totals.toFixed(2));

    if (amountSum === 0) {
        return 'error';
    }

    if (cont && filledany && amount && deds) {
        return 'success';
    }

    if (cont && filledany) {
        return 'warning';
    }

    return 'error';
};

export default useStage2;
